export type MonitorType =
  | 'GPT_API'
  | 'GPT'
  | 'ALL'
  | 'GPT_SEARCH_BROWSER'
  | 'GPT_API_BROWSER'
  | 'GPT_API_SEARCH_WEB'
  | 'GEMINI_API'
  | 'GEMINI_API_BROWSER'
  | 'CLAUDE_API'
  | 'DEEP_SEEK_API'
  | 'PERPLEXITY_API'
  | 'PERPLEXITY_SEARCH_BROWSER'
  | 'GROK_API'
  | 'AI_OVERVIEW'
  | 'AI_OVERVIEW_NEW'
  | 'AI_MODE'
  | 'GROK_SEARCH_BROWSER'
  | 'COPILOT_SEARCH_BROWSER'
  | 'GEMINI_SEARCH_BROWSER';

export const allMonitorTypes = [
  'GPT_SEARCH_BROWSER',
  'GPT_API_BROWSER',
  'GEMINI_API',
  'CLAUDE_API',
  'DEEP_SEEK_API',
  'PERPLEXITY_API',
  'PERPLEXITY_SEARCH_BROWSER',
  'GROK_API',
  'AI_OVERVIEW',
  'AI_OVERVIEW_NEW',
  'AI_MODE',
  'GROK_SEARCH_BROWSER',
  'COPILOT_SEARCH_BROWSER',
  'GEMINI_SEARCH_BROWSER',
];
